import { Transition } from "../../../core/flows/Transition";
import { SearchContext } from "../../Common/Search/Context/SearchContext";
import { SelectOfferContext } from "../../TrainOfferPage/SelectOfferFlow/Context/SelectOfferContext";
import { TicketOptionContext } from "../../TrainOfferPage/TicketOptionFlow/Context/TicketOptionContext";
import { FmlmViewContext } from "../Context/FmlmViewContext";

export class FmlmViewTransition extends Transition {
  constructor(entryStep: string, exitSteps: string[]) {
    super(entryStep, exitSteps);
  }

  onExecute(): string[] {
    const fmlmContext = this.getCtx<FmlmViewContext>("FmlmViewContext", this.entryStep)!;

    const selectOfferContext = new SelectOfferContext()
    this.setCtx<SelectOfferContext>("SelectOfferContext", selectOfferContext, this.entryStep)

    const ticketOptionContext = new TicketOptionContext()
    this.setCtx<TicketOptionContext>("ticketOptionContext", ticketOptionContext, this.entryStep);

    const searchContext = this.getCtx<SearchContext>("searchContext", this.entryStep);
    if (!searchContext) {
      const newSearchContext = new SearchContext()
      this.setCtx<SearchContext>("searchContext", newSearchContext, this.entryStep)
    }

    if (!fmlmContext) {
      console.log("[Transition] No choice data available, using default exits");
      return this.exitSteps;
    }

    if (!(fmlmContext.routeTo ?? []).every(step => this.exitSteps.includes(step))) {
      console.log(`[Transition] Invalid choice: ${fmlmContext.routeTo}`);
      return [];
    }

    return [...(fmlmContext?.routeTo ?? [])]
  }
}